// removed by extract-text-webpack-plugin
module.exports = {"formBlock":"formBlock__1UMo7","danger":"danger__1Hh3U","closeButton":"closeButton__Xju16","success":"success__3cilR","warning":"warning__11Whl","primary":"primary__3pHhL","info":"info__u7jcr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormBlock/styles.scss
// module id = 2129
// module chunks = 1